/* =====================================================================
   Annette D. — frise de la page « À propos » (sections/annetted-apropos.liquid)
   ---------------------------------------------------------------------
   Pendant que la colonne du récit reste à l'écran, un segment encre
   descend le long du filet de la frise jusqu'au jalon qu'on lit, et les
   jalons à venir passent en pastille creuse.

   Le jalon lu est celui qui traverse la bande centrale de l'écran
   (observateur, rootMargin −45 % en haut et en bas) : pas d'écouteur de
   défilement, qui viserait de toute façon `.page-wrapper` et non le
   document dans Horizon. Sans script, la frise garde son filet et des
   pastilles pleines : rien n'est caché.
   ===================================================================== */

(() => {
  const SUIVIE = 'annetted-frise--suivie';
  const ACTIF = 'annetted-frise__jalon--actif';
  const ATTEINT = 'annetted-frise__jalon--atteint';

  const brancher = (racine = document) => {
    if (!('IntersectionObserver' in window)) return;

    racine.querySelectorAll('[data-annetted-frise]').forEach((frise) => {
      if (frise.annettedPret) return;
      frise.annettedPret = true;

      const jalons = Array.from(frise.querySelectorAll(':scope > [data-annetted-jalon]'));
      if (!jalons.length) return;

      let actif = jalons[0];

      const activer = (jalon) => {
        actif = jalon;
        const rang = jalons.indexOf(jalon);
        jalons.forEach((j, i) => {
          j.classList.toggle(ACTIF, j === jalon);
          j.classList.toggle(ATTEINT, i <= rang);
        });

        // Le segment s'arrête au centre de la pastille du jalon lu. Mesure
        // en offsetTop (la mise en page, pas l'écran) : un jalon encore
        // décalé par sa révélation ne fausse pas la longueur.
        const pastille = jalon.querySelector('.annetted-frise__pastille');
        const longueur = jalon.offsetTop + (pastille ? pastille.offsetTop + pastille.offsetHeight / 2 : 0);
        frise.style.setProperty('--annetted-frise-segment', `${Math.round(Math.max(0, longueur))}px`);
      };

      const observateur = new IntersectionObserver(
        (entrees) => {
          const visibles = entrees.filter((entree) => entree.isIntersecting);
          if (!visibles.length) return;
          // Plusieurs jalons dans la bande (petit écran) : le plus bas l'emporte.
          visibles.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          activer(visibles[visibles.length - 1].target);
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );

      jalons.forEach((jalon) => observateur.observe(jalon));
      frise.classList.add(SUIVIE);
      activer(actif);

      // Une police qui arrive ou un écran qui pivote déplacent les pastilles.
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => activer(actif)).observe(frise);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => brancher(), { once: true });
  } else {
    brancher();
  }

  document.addEventListener('shopify:section:load', (event) => brancher(event.target));
})();
